/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Export_Fields_Origin_SpecificInputs */



/**
* | output |
* | --- |
* | "Origin-specific" |
*
* @param {Audit_Export_Fields_Origin_SpecificInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_export_fields_origin_specific = /** @type {((inputs?: Audit_Export_Fields_Origin_SpecificInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Export_Fields_Origin_SpecificInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Herkunftsspezifisch")
	return /** @type {LocalizedString} */ ("Origin-specific")
});